export default (opts = {}) => {
  const component = {
    model: {
      defaults: {
        type:'section', 
        tagname:'section',
        name: "Seção Blog",
        attributes: { class: 'section overflow-hidden' },
        components: [
          {
            type: 'containerBlog3'
          }          
        ],
        styles: `
       .section{
        padding:75px 5%; 
       }
        .overflow-hidden{
          overflow-x: hidden;
          overflow-y: hidden; 
        }
        *{
          font-family: Roboto, Arial, sans-serif;
       }
      `,
       },
    },
    view: {

    },
  };

  return component;
};

